import React from "react";
import { useNavigate } from 'react-router-dom';
import { Button } from "antd";
import "./topCakes.css";
import { Cakes } from "./cakeIds"

const TopCakes = () => {
  const navigate = useNavigate();

  const onCardClick = (cakeId) => {
    navigate(`/cakes/${cakeId}`);
  };

  return (
    <div
        className="container-sm px-4 px-xs-5 px-sm-0 align-items-center justify-content-center home__topnft"
        id="top-orders">
        <hr/>
        <div className="row">
          <div className="col-md-3 col-sm-6 py-2 gap-4 d-flex flex-column align-items-center">
            <div className="bg-white rounded_div shadow-lg overflow-hidden flex-1 flex flex-col" role="button" onClick={() => onCardClick(Cakes.RAFAELLO)}>
              <img
                  src="/assets/cakes/raffaello-cake.jpg"
                  alt=""
                  className="home__topnft_img"/>
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="mb-4 text-2xl">Raffaello cake</h3>
                <div className="mb-4 text-grey-darker text-sm flex-1"></div>
                <Button type="primary" className="col-md-4" onClick={(e) => { e.stopPropagation(); onCardClick(Cakes.RAFAELLO); }}>
                  Order
                </Button>
              </div>
            </div>
          </div>

          <div className="col-md-3 col-sm-6 py-2 gap-4 d-flex flex-column align-items-center">
            <div className="bg-white rounded_div shadow-lg overflow-hidden flex-1 flex flex-col" role="button" onClick={() => onCardClick(Cakes.CROWN)}>
              <img
                  src="/assets/cakes/crown-cake.jpg"
                  alt=""
                  className="home__topnft_img"/>
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="mb-4 text-2xl">Crown birthday/wedding cake</h3>
                <div className="mb-4 text-grey-darker text-sm flex-1">
                </div>
                <Button type="primary" className="col-md-4" onClick={(e) => { e.stopPropagation(); onCardClick(Cakes.CROWN); }}>
                  Order
                </Button>
              </div>
            </div>
          </div>

          <div className="col-md-3 col-sm-6 py-2 gap-4 d-flex flex-column align-items-center">
            <div className="bg-white rounded_div shadow-lg overflow-hidden flex-1 flex flex-col" role="button" onClick={() => onCardClick(Cakes.CINNAMOROLL_CAKE)}>
              <img
                  src="/assets/cakes/cinnamoroll-cake.jpg"
                  alt=""
                  className="home__topnft_img"/>
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="mb-4 text-2xl">Cinnamoroll cake</h3>
                <div className="mb-4 text-grey-darker text-sm flex-1"></div>
                Without decoration <p></p>
                <Button type="primary" className="col-md-4" onClick={(e) => { e.stopPropagation(); onCardClick(Cakes.CINNAMOROLL_CAKE); }}>
                  Order
                </Button>
              </div>
            </div>
          </div>

          <div className="col-md-3 col-sm-6 py-2 gap-4 d-flex flex-column align-items-center">
            <div className="bg-white rounded_div shadow-lg overflow-hidden flex-1 flex flex-col" role="button" onClick={() => onCardClick(Cakes.CUSTOMIZED_BDAY_CAKE)}>
              <img
                  src="/assets/cakes/custom-cake.jpg"
                  alt=""
                  className="home__topnft_img"/>
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="mb-4 text-2xl">Customized birthday/wedding cake</h3>
                <div className="mb-4 text-grey-darker text-sm flex-1"></div>
                <Button type="primary" className="col-md-4" onClick={(e) => { e.stopPropagation(); onCardClick(Cakes.CUSTOMIZED_BDAY_CAKE); }}>
                  Order
                </Button>
              </div>
            </div>
          </div>

          <div className="col-md-3 col-sm-6 py-2 gap-4 d-flex flex-column align-items-center">
            <div className="bg-white rounded_div shadow-lg overflow-hidden flex-1 flex flex-col" role="button" onClick={() => onCardClick(Cakes.HONEY_CAKE)}>
              <img
                  src="/assets/cakes/honey-cake.jpg"
                  alt=""
                  className="home__topnft_img"
              />
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="mb-4 text-2xl">Honey cake</h3>
                <div className="mb-4 text-grey-darker text-sm"></div>
                <Button type="primary" className="col-md-4" onClick={(e) => { e.stopPropagation(); onCardClick(Cakes.HONEY_CAKE); }}>
                  Order
                </Button>
              </div>
            </div>
          </div>

          <div className="col-md-3 col-sm-6 py-2 gap-4 d-flex flex-column align-items-center">
            <div className="bg-white rounded_div shadow-lg overflow-hidden flex-1 flex flex-col" role="button" onClick={() => onCardClick(Cakes.NAPOLEON_PLAIN)}>
              <img
                  src="/assets/cakes/napaleon-2.jpg"
                  alt=""
                  className="home__topnft_img"
              />
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="mb-4 text-2xl">Classic Napoleon cake</h3>
                <div className="mb-4 text-grey-darker text-sm"></div>
                <Button type="primary" className="col-md-4" onClick={(e) => { e.stopPropagation(); onCardClick(Cakes.NAPOLEON_PLAIN); }}>
                  Order
                </Button>
              </div>
            </div>
          </div>

          <div className="col-md-3 col-sm-6 py-2 gap-4 d-flex flex-column align-items-center">
            <div className="bg-white rounded_div shadow-lg overflow-hidden flex-1 flex flex-col" role="button" onClick={() => onCardClick(Cakes.SAMAR_CAKE)}>
              <img
                  src="/assets/cakes/kids-birthday-cake-construction.jpg"
                  alt=""
                  className="home__topnft_img"
              />
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="mb-4 text-2xl">Truffle Kids birthday Samar cake</h3>
                <div className="mb-4 text-grey-darker text-sm"></div>
                <Button type="primary" className="col-md-4" onClick={(e) => { e.stopPropagation(); onCardClick(Cakes.SAMAR_CAKE); }}>
                  Order
                </Button>
              </div>
            </div>
          </div>

          <div className="col-md-3 col-sm-6 py-2 gap-4 d-flex flex-column align-items-center">
            <div className="bg-white rounded_div shadow-lg overflow-hidden flex-1 flex flex-col" role="button" onClick={() => onCardClick(Cakes.NUMBERS_BDAY_CAKE)}>
              <img
                  src="/assets/cakes/numbers-cake.jpg"
                  alt=""
                  className="home__topnft_img"
              />
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="mb-4 text-2xl">Numbers birthday cake</h3>
                <div className="mb-4 text-grey-darker text-sm"></div>
                <Button type="primary" className="col-md-4" onClick={(e) => { e.stopPropagation(); onCardClick(Cakes.NUMBERS_BDAY_CAKE); }}>
                  Order
                </Button>
              </div>
            </div>
          </div>

          <div className="col-md-3 col-sm-6 py-2 gap-4 d-flex flex-column align-items-center">
            <div className="bg-white rounded_div shadow-lg overflow-hidden flex-1 flex flex-col" role="button" onClick={() => onCardClick(Cakes.NAPOLEON_WITH_BERRIES)}>
              <img
                  src="/assets/cakes/napaleon-with-berries.jpg"
                  alt=""
                  className="home__topnft_img"
              />
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="mb-4 text-2xl">Napoleon with berries</h3>
                <div className="mb-4 text-grey-darker text-sm"></div>
                <Button type="primary" className="col-md-4" onClick={(e) => { e.stopPropagation(); onCardClick(Cakes.NAPOLEON_WITH_BERRIES); }}>
                  Order
                </Button>
              </div>
            </div>
          </div>

          <div className="col-md-3 col-sm-6 py-2 gap-4 d-flex flex-column align-items-center">
            <div className="bg-white rounded_div shadow-lg overflow-hidden flex-1 flex flex-col" role="button" onClick={() => onCardClick(Cakes.BLACK_CAKE)}>
              <img
                  src="/assets/cakes/black-cake.jpg"
                  alt=""
                  className="home__topnft_img"
              />
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="mb-4 text-2xl">Black cake</h3>
                <div className="mb-4 text-grey-darker text-sm"></div>
                <Button type="primary" className="col-md-4" onClick={(e) => { e.stopPropagation(); onCardClick(Cakes.BLACK_CAKE); }}>
                  Order
                </Button>
              </div>
            </div>
          </div>

          <div className="col-md-3 col-sm-6 py-2 gap-4 d-flex flex-column align-items-center">
            <div className="bg-white rounded_div shadow-lg overflow-hidden flex-1 flex flex-col" role="button" onClick={() => onCardClick(Cakes.BABY_SHOWER_CAKE)}>
              <img
                  src="/assets/cakes/baby-shower.jpg"
                  alt=""
                  className="home__topnft_img"
              />
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="mb-4 text-2xl">Baby Shower cake</h3>
                <div className="mb-4 text-grey-darker text-sm"></div>
                <Button type="primary" className="col-md-4" onClick={(e) => { e.stopPropagation(); onCardClick(Cakes.BABY_SHOWER_CAKE); }}>
                  Order
                </Button>
              </div>
            </div>
          </div>

          <div className="col-md-3 col-sm-6 py-2 gap-4 d-flex flex-column align-items-center">
            <div className="bg-white rounded_div shadow-lg overflow-hidden flex-1 flex flex-col" role="button" onClick={() => onCardClick(Cakes.GRADUATION_CAKE)}>
              <img
                  src="/assets/cakes/graduation-cake.jpeg"
                  alt=""
                  className="home__topnft_img"
              />
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="mb-4 text-2xl">Graduation cake</h3>
                <div className="mb-4 text-grey-darker text-sm"></div>
                <Button type="primary" className="col-md-4" onClick={(e) => { e.stopPropagation(); onCardClick(Cakes.GRADUATION_CAKE); }}>
                  Order
                </Button>
              </div>
            </div>
          </div>

          <div className="col-md-3 col-sm-6 py-2 gap-4 d-flex flex-column align-items-center">
            <div className="bg-white rounded_div shadow-lg overflow-hidden flex-1 flex flex-col" role="button" onClick={() => onCardClick(Cakes.GRADUATION_CAKE_2)}>
              <img
                  src="/assets/cakes/graduation-cake-2.jpg"
                  alt=""
                  className="home__topnft_img"
              />
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="mb-4 text-2xl">Graduation cake</h3>
                <div className="mb-4 text-grey-darker text-sm"></div>
                <Button type="primary" className="col-md-4" onClick={(e) => { e.stopPropagation(); onCardClick(Cakes.GRADUATION_CAKE_2); }}>
                  Order
                </Button>
              </div>
            </div>
          </div>

          <div className="col-md-3 col-sm-6 py-2 gap-4 d-flex flex-column align-items-center">
            <div className="bg-white rounded_div shadow-lg overflow-hidden flex-1 flex flex-col" role="button" onClick={() => onCardClick(Cakes.WEDDING_CAKE)}>
              <img
                  src="/assets/cakes/wedding-cakes.jpg"
                  alt=""
                  className="home__topnft_img"
              />
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="mb-4 text-2xl">Wedding cake</h3>
                <div className="mb-4 text-grey-darker text-sm"></div>
                <Button type="primary" className="col-md-4" onClick={(e) => { e.stopPropagation(); onCardClick(Cakes.WEDDING_CAKE); }}>
                  Order
                </Button>
              </div>
            </div>
          </div>

          <div className="col-md-3 col-sm-6 py-2 gap-4 d-flex flex-column align-items-center">
            <div className="bg-white rounded_div shadow-lg overflow-hidden flex-1 flex flex-col" role="button" onClick={() => onCardClick(Cakes.BIRTHDAY_QUEEN)}>
              <img
                  src="/assets/cakes/birthday-queen.jpg"
                  alt=""
                  className="home__topnft_img"
              />
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="mb-4 text-2xl">Birthday Queen cake</h3>
                <div className="mb-4 text-grey-darker text-sm"></div>
                <Button type="primary" className="col-md-4" onClick={(e) => { e.stopPropagation(); onCardClick(Cakes.BIRTHDAY_QUEEN); }}>
                  Order
                </Button>
              </div>
            </div>
          </div>

          <div className="col-md-3 col-sm-6 py-2 gap-4 d-flex flex-column align-items-center">
            <div className="bg-white rounded_div shadow-lg overflow-hidden flex-1 flex flex-col" role="button" onClick={() => onCardClick(Cakes.PIKACHU_CAKE)}>
              <img
                  src="/assets/cakes/pikachu-cake.jpg"
                  alt=""
                  className="home__topnft_img"
              />
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="mb-4 text-2xl">Pikachu cake</h3>
                <div className="mb-4 text-grey-darker text-sm"></div>
                <Button type="primary" className="col-md-4" onClick={(e) => { e.stopPropagation(); onCardClick(Cakes.PIKACHU_CAKE); }}>
                  Order
                </Button>
              </div>
            </div>
          </div>

          <div className="col-md-3 col-sm-6 py-2 gap-4 d-flex flex-column align-items-center">
            <div className="bg-white rounded_div shadow-lg overflow-hidden flex-1 flex flex-col" role="button" onClick={() => onCardClick(Cakes.KUROMI_CAKE)}>
              <img
                  src="/assets/cakes/kuromi.jpg"
                  alt=""
                  className="home__topnft_img"
              />
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="mb-4 text-2xl">Kuromi cake</h3>
                <div className="mb-4 text-grey-darker text-sm"></div>
                <Button type="primary" className="col-md-4" onClick={(e) => { e.stopPropagation(); onCardClick(Cakes.KUROMI_CAKE); }}>
                  Order
                </Button>
              </div>
            </div>
          </div>

          <div className="col-md-3 col-sm-6 py-2 gap-4 d-flex flex-column align-items-center">
            <div className="bg-white rounded_div shadow-lg overflow-hidden flex-1 flex flex-col" role="button" onClick={() => onCardClick(Cakes.PEPPA_PIG_CAKE)}>
              <img
                  src="/assets/cakes/peppa-pig.jpg"
                  alt=""
                  className="home__topnft_img"
              />
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="mb-4 text-2xl">Peppa Pig cake</h3>
                <div className="mb-4 text-grey-darker text-sm"></div>
                <Button type="primary" className="col-md-4" onClick={(e) => { e.stopPropagation(); onCardClick(Cakes.PEPPA_PIG_CAKE); }}>
                  Order
                </Button>
              </div>
            </div>
          </div>

          <div className="col-md-3 col-sm-6 py-2 gap-4 d-flex flex-column align-items-center">
            <div className="bg-white rounded_div shadow-lg overflow-hidden flex-1 flex flex-col" role="button" onClick={() => onCardClick(Cakes.WAFFLE_ROSE_CAKE)}>
              <img
                  src="/assets/cakes/waffle-rose-cake.jpg"
                  alt=""
                  className="home__topnft_img"
              />
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="mb-4 text-2xl">Waffle Rose cake</h3>
                <div className="mb-4 text-grey-darker text-sm"></div>
                <Button type="primary" className="col-md-4" onClick={(e) => { e.stopPropagation(); onCardClick(Cakes.WAFFLE_ROSE_CAKE); }}>
                  Order
                </Button>
              </div>
            </div>
          </div>
        </div>
    </div>
  );
};

export default TopCakes;
